import {
  BeforeMatchQuestion,
  BeforeMatchQuestionOption,
} from "@app/core/match/domain/model/before-match-question";
import { PlayerIdentificationData } from "@app/core/match/domain/model/player-identification-data";

export class PlayerIdentificationMapper {
  static deserialize(response: any): PlayerIdentificationData {
    return {
      questions: PlayerIdentificationMapper.deserializeQuestions(
        response.questions
      ),
    };
  }

  /**
   * Old backend deploys don't send `questions` yet: default to an empty
   * list rather than throwing, so the flow degrades gracefully until both
   * sides of the contract are live.
   */
  private static deserializeQuestions(questions: any): BeforeMatchQuestion[] {
    if (!Array.isArray(questions)) return [];
    return questions.map((question) => ({
      id: question.id,
      type: question.type,
      text: question.text,
      hint: question.hint ?? undefined,
      required: !!question.required,
      columns: question.columns ?? 1,
      maxChoices: question.max_choices ?? undefined,
      image: question.image ?? undefined,
      options: PlayerIdentificationMapper.deserializeOptions(question.options),
    }));
  }

  private static deserializeOptions(options: any): BeforeMatchQuestionOption[] {
    if (!Array.isArray(options)) return [];
    return options.map((option) => ({
      value: option.value,
      label: option.label,
      icon: option.icon ?? undefined,
      color: option.color ?? undefined,
      freeText: !!option.free_text,
      image: option.image ?? undefined,
      disabled: !!option.disabled,
    }));
  }
}
